import { PpfRouteData } from "@ppf/shared/data";

const baseRoute = "quote";

export const leadIdParameter = ":leadId";

export const QUOTE_ROUTE_DATA: PpfRouteData = {
	base: {
		route: baseRoute,
		fullRoute: `/${baseRoute}`,
	},
	none: {
		route: "none",
		fullRoute: `/${baseRoute}/none`,
	},
	outOfMarket: {
		route: "out-of-market",
		fullRoute: `/${baseRoute}/out-of-market`,
	},
	quoteDetails: {
		route: leadIdParameter,
		fullRoute: `/${baseRoute}/${leadIdParameter}`,
	},
	schedule: {
		route: "schedule",
		fullRoute: `/${baseRoute}/:leadId/schedule`,
	},
	scheduleSuccess: {
		route: "success",
		fullRoute: `/${baseRoute}/:leadId/schedule/success`,
	},
};
